(function () {
    'use strict';

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const MIXPANEL_BRIDGE_KEY = 'mixpanel:bridge';
    const MIXPANEL_BRIDGE_VERSION = 1;

    const isPlainObject = value => typeof value === 'object' && value !== null && !Array.isArray(value);
    const persist = (merged, fresh) => {
      try {
        sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
          v: MIXPANEL_BRIDGE_VERSION,
          ...merged
        }));
      } catch {
        try {
          sessionStorage.removeItem(MIXPANEL_BRIDGE_KEY);
          sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
            v: MIXPANEL_BRIDGE_VERSION,
            ...fresh
          }));
        } catch {
          return;
        }
      }
    };
    const readBridge = () => {
      try {
        const raw = sessionStorage.getItem(MIXPANEL_BRIDGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return isPlainObject(parsed) ? parsed : {};
      } catch {
        return {};
      }
    };
    const writeBridgeFields = fields => {
      persist({
        ...readBridge(),
        ...fields
      }, fields);
    };

    document.addEventListener('DOMContentLoaded', () => {
      const pdpVariant = document.querySelector('[data-pdp-variant]')?.dataset.pdpVariant;
      if (pdpVariant) writeBridgeFields({
        pdp_variant: pdpVariant
      });
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return pdp$1; }), Promise.resolve().then(function () { return componentTabs$1; }), Promise.resolve().then(function () { return componentZoomableImage$1; }), Promise.resolve().then(function () { return componentProductXyz3d$1; }), Promise.resolve().then(function () { return componentProductPackshot$1; }), Promise.resolve().then(function () { return componentProductBuyBar$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    const {
      isMobile: isMobile$1
    } = window.PoleneLibs.Utils;
    class PDP {
      footer = null;
      CTA = null;
      footerObserver = null;
      constructor({
        productMain
      }) {
        this.productMain = productMain;
        this.initElements();
        this.initFooterObserver();
      }
      initElements() {
        this.footer = document.querySelector('#shopify-section-footer');
        const {
          addToCart
        } = getElementByRef$1('add-to-cart', this.productMain);
        if (addToCart) {
          this.CTA = addToCart;
        }
      }
      initFooterObserver() {
        if (this.footer) {
          this.footerObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.CTA?.classList.add('footer-visible');
              } else {
                this.CTA?.classList.remove('footer-visible');
              }
            });
          }, {
            rootMargin: '-100px 0px 0px 0px',
            threshold: 0
          });
          this.footerObserver.observe(this.footer);
        }
      }
      destroy() {
        if (this.footerObserver) {
          this.footerObserver.disconnect();
          this.footerObserver = null;
        }
      }
    }
    var pdp = async () => {
      const {
        productMain
      } = getElementByRef$1('product-main');
      if (productMain && isMobile$1()) {
        try {
          const pdp = new PDP({
            productMain
          });
          return () => {
            pdp.destroy();
          };
        } catch (error) {}
      }
    };

    var pdp$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: pdp
    });

    const {
      getElementsByRef
    } = window.PoleneLibs.Refs;
    class ComponentTabs extends HTMLElement {
      tabs = [];
      panels = [];
      activePanel = undefined;
      activeTab = undefined;
      isLastInFocusTrap = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          tab,
          tabPanel
        } = getElementsByRef(['tab', 'tab-panel'], this);
        if (!tab || !tabPanel) return;
        this.tabs = Array.isArray(tab) ? tab : [tab];
        this.panels = Array.isArray(tabPanel) ? tabPanel : [tabPanel];
        this.activeTab = this.tabs.find(trigger => trigger?.classList.contains('active'));
        this.activePanel = this.panels.find(panel => panel?.classList.contains('active') && this.activeTab?.dataset.panelId === panel.id);
        this.isLastInFocusTrap = this.dataset.isLastInFocusTrap === 'true';
      };
      setupEventListeners = () => {
        this.tabs.forEach(tab => tab?.addEventListener('click', this.handleClick));
      };
      removeEventListeners = () => {
        this.tabs.forEach(tab => tab?.removeEventListener('click', this.handleClick));
      };
      setupAccessibility = () => {
        if (this.isLastInFocusTrap) {
          this.panels.forEach(panel => {
            if (panel && panel.lastElementChild) panel.lastElementChild.setAttribute('data-is-last-focus', 'true');
          });
        }
      };
      handleClick = event => {
        const triggeredTab = event.currentTarget;
        const {
          panelId
        } = triggeredTab.dataset;
        if (triggeredTab === this.activeTab) return;
        this.switchTab(triggeredTab);
        if (panelId) this.switchPanel(panelId);
      };
      switchTab = targetTab => {
        if (this.activeTab) {
          this.activeTab.classList.remove('active');
          this.activeTab.ariaSelected = 'false';
        }
        if (!targetTab.classList.contains('active')) {
          targetTab.classList.add('active');
          targetTab.ariaSelected = 'true';
        }
        this.activeTab = targetTab;
      };
      switchPanel = targetPanelId => {
        const newActivePanel = this.panels.find(panel => targetPanelId === panel?.id);
        if (this.activePanel) {
          this.activePanel.classList.remove('active');
          this.activePanel.ariaHidden = 'true';
        }
        if (newActivePanel && !newActivePanel.classList.contains('active')) {
          newActivePanel.classList.add('active');
          newActivePanel.ariaHidden = 'false';
          this.activePanel = newActivePanel;
        }
      };
      static define = () => {
        if (!customElements.get('component-tabs')) {
          customElements.define('component-tabs', ComponentTabs);
        }
      };
    }
    var componentTabs = () => {
      ComponentTabs.define();
    };

    var componentTabs$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentTabs: ComponentTabs,
        default: componentTabs
    });

    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    class ComponentZoomableImage extends HTMLElement {
      controller = undefined;
      themeContainer = undefined;
      fsImageContainer = undefined;
      zoomBtn = undefined;
      isZoomed = false;
      rect = undefined;
      cursorX = 0;
      cursorY = 0;
      addedFullscreenClass = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      initializeElements = () => {
        const {
          themeZoomableImage
        } = getElementByRef('theme-zoomable-image');
        const {
          fsImageContainer,
          imageZoomTrigger
        } = getElementByRef(['fs-image-container', 'image-zoom-trigger'], this);
        this.themeContainer = themeZoomableImage;
        this.fsImageContainer = fsImageContainer;
        this.zoomBtn = imageZoomTrigger;
        this.rect = this.getBoundingClientRect();
        if (this.themeContainer && this.fsImageContainer) this.themeContainer.appendChild(this.fsImageContainer);
      };
      setupEventListeners = () => {
        this.zoomBtn?.addEventListener('click', this.handleClick, {
          signal: this.controller?.signal
        });
        this.zoomBtn?.addEventListener('focusout', this.handleFocusout, {
          signal: this.controller?.signal
        });
        this.addEventListener('mouseenter', this.handleMouseEnter, {
          signal: this.controller?.signal
        });
        this.addEventListener('mouseleave', this.handleMouseLeave, {
          signal: this.controller?.signal
        });
        this.addEventListener('mousemove', this.handleMouseMove, {
          signal: this.controller?.signal
        });
        this.addEventListener('keydown', this.handleKeyDown, {
          signal: this.controller?.signal
        });
        this.fsImageContainer?.addEventListener('click', this.handleClick, {
          signal: this.controller?.signal
        });
        this.fsImageContainer?.addEventListener('mousemove', this.handleMouseMove, {
          signal: this.controller?.signal
        });
      };
      handleFocusout = e => {
        if (this.isZoomed && this.zoomBtn) {
          e.preventDefault();
          this.zoomBtn.focus();
        }
      };
      handleKeyDown = e => {
        if (e.key === 'Escape' && this.isZoomed) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.zoomOut();
        }
      };
      handleClick = () => {
        if (!this.isZoomed) this.zoomIn();else this.zoomOut();
      };
      zoomIn = () => {
        dispatchEvent(window, events$1.CHANGE_CURSOR, {
          type: 'close',
          contrast: true
        });
        this.showImage();
        if (this.zoomBtn) this.zoomBtn.ariaPressed = 'true';
        this.isZoomed = true;
        if (!document.body.classList.contains('fullscreen-active')) {
          document.body.classList.add('fullscreen-active');
          this.addedFullscreenClass = true;
        } else {
          this.addedFullscreenClass = false;
        }
      };
      zoomOut = () => {
        if (this.isCursorInRect()) dispatchEvent(window, events$1.CHANGE_CURSOR, {
          type: 'zoom',
          contrast: true
        });else dispatchEvent(window, events$1.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
        this.hideImage();
        if (this.zoomBtn) this.zoomBtn.ariaPressed = 'false';
        this.isZoomed = false;
        if (this.addedFullscreenClass) {
          document.body.classList.remove('fullscreen-active');
          this.addedFullscreenClass = false;
        }
      };
      showImage = () => {
        if (!this.fsImageContainer || !this.themeContainer) return;
        this.fsImageContainer.classList.add('active');
        this.fsImageContainer.ariaHidden = 'false';
        this.themeContainer.classList.add('active');
        this.themeContainer.ariaHidden = 'false';
        this.scrollToCenter(this.fsImageContainer);
      };
      hideImage = () => {
        if (!this.fsImageContainer || !this.themeContainer) return;
        this.fsImageContainer.classList.remove('active');
        this.fsImageContainer.ariaHidden = 'true';
        this.themeContainer.classList.remove('active');
        this.themeContainer.ariaHidden = 'true';
      };
      handleMouseEnter = () => {
        if (this.isZoomed) return;
        dispatchEvent(window, events$1.CHANGE_CURSOR, {
          type: 'zoom',
          contrast: true
        });
      };
      handleMouseLeave = () => {
        if (this.isZoomed) return;
        dispatchEvent(window, events$1.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
      };
      handleMouseMove = e => {
        this.cursorX = e.clientX;
        this.cursorY = e.clientY;
      };
      isCursorInRect = () => {
        this.rect = this.getBoundingClientRect();
        return this.rect && this.cursorX >= this.rect.left && this.cursorX <= this.rect.right && this.cursorY >= this.rect.top && this.cursorY <= this.rect.bottom;
      };
      scrollToCenter = container => {
        container.scrollLeft = container.scrollWidth / 2 - container.clientWidth / 2;
        container.scrollTop = container.scrollHeight / 2 - container.clientHeight / 2;
      };
      static define = () => {
        if (!customElements.get('component-zoomable-image')) customElements.define('component-zoomable-image', ComponentZoomableImage);
      };
    }
    var componentZoomableImage = () => {
      ComponentZoomableImage.define();
    };

    var componentZoomableImage$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentZoomableImage: ComponentZoomableImage,
        default: componentZoomableImage
    });

    const {
      buildPowerXyzUrl,
      isMobile
    } = window.PoleneLibs.Utils;
    class ProductXYZ3D extends HTMLElement {
      controller = undefined;
      isEnabled = this.hasAttribute('is-enabled') || false;
      powerInstance = null;
      trigger = null;
      packshotContainer = null;
      packshotImg = null;
      isPackshot = this.dataset?.isPackshot === 'true' || false;
      viewerButtons = null;
      secondarySKU = this.getAttribute('data-secondary-sku') || null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
      }
      disconnectedCallback() {
        this.resetPackshotState();
        this.powerInstance = null;
        this.controller?.abort();
      }
      initializeElements = async () => {
        const viewer = this.querySelector('power-viewer');
        if (!viewer) {
          throw new Error('Viewer not found');
        }
        this.viewer = viewer;
        if (!this.isEnabled) {
          this.destroy();
        }
        if (isMobile()) {
          if (!this.classList.contains('sm-only')) {
            this.destroy();
          }
        } else {
          if (this.classList.contains('sm-only')) {
            this.destroy();
          }
        }
        const isMain3dAvailable = await this.check3DAvailability(this.viewer.getAttribute('company-eid') || '', this.viewer.getAttribute('sku') || '');
        if (this.secondarySKU) {
          const isSecondary3dAvailable = await this.check3DAvailability(this.viewer.getAttribute('company-eid') || '', this.secondarySKU);
          if (!isSecondary3dAvailable) {
            this.trigger?.classList.add('is-hidden');
          }
        }
        const viewerButtons = this.querySelector('[data-ref="viewer-buttons"]');
        const packshotImg = this.querySelector('img.packshot-img');
        const packshotContainerSelector = isMobile() ? '.product-packshot__container' : '.product-packshot__container-desktop';
        if (packshotImg) {
          this.packshotImg = packshotImg;
        }
        this.packshotContainer = document.querySelector(packshotContainerSelector);
        if (!this.packshotContainer) return;
        if (viewerButtons) {
          this.viewerButtons = viewerButtons;
        }
        if (this.dataset.insideTrigger) {
          const xyzTriggerViewInside = this.querySelector(`[data-ref='${this.dataset.insideTrigger}'] input[type="checkbox"]	`);
          if (xyzTriggerViewInside) {
            this.trigger = xyzTriggerViewInside;
          }
        }
        if (isMain3dAvailable) {
          const viewerId = this.viewer.getAttribute('id');
          if (!viewerId) {
            throw new Error('Viewer ID not found');
          }
          if (this.powerInstance) return;
          if (typeof POWERViewer === 'undefined') {
            return;
          }
          this.powerInstance = new POWERViewer({
            id: viewerId
          });
          this.setupEventListeners();
        } else {
          this.destroy();
        }
      };
      destroy = () => {
        const viewerContainer = this.querySelector('[data-ref="xyz-viewer-container"]');
        if (viewerContainer) {
          viewerContainer.remove();
        }
      };
      setupEventListeners = () => {
        if (this.trigger) {
          this.trigger?.addEventListener('click', this.handleTriggerClick, {
            signal: this.controller?.signal
          });
          this.trigger?.addEventListener('keydown', this.handleTriggerKeydown, {
            signal: this.controller?.signal
          });
        }
        this.powerInstance?.onLoad(() => {
          this.toggleViewer();
        });
        document.addEventListener('modal', event => {
          const modalEvent = event;
          if (modalEvent.detail.type === 'gallery' && modalEvent.detail.action) {
            this.updatePackshotGalleryViewer({
              galleryState: modalEvent.detail.action
            });
          }
          if (modalEvent.detail.type === '3d-viewer') {
            this.toggleViewer();
          }
        });
      };
      handleTriggerKeydown = e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.trigger?.click();
        }
      };
      handleTriggerClick = () => {
        const primarySKU = this.getAttribute('sku');
        const secondarySKU = this.getAttribute('secondary-sku');
        if (this.trigger?.checked) {
          this.trigger.value = 'open';
          if (secondarySKU) {
            this.viewer.setAttribute('sku', secondarySKU);
          }
        } else {
          if (this.trigger) this.trigger.value = 'close';
          if (primarySKU) {
            this.viewer.setAttribute('sku', primarySKU);
          }
        }
      };
      check3DAvailability = async (companyEid, SKU) => {
        const url = buildPowerXyzUrl(companyEid, SKU);
        if (!url) return false;
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return true;
        } catch (error) {
          return false;
        }
      };
      toggleViewer = () => {
        this.viewer?.classList.remove('is-hidden');
        this.querySelector('[data-ref="xyz-viewer-container"]')?.classList.remove('is-hidden');
        if (this.viewer.getAttribute('start') && this.viewer.getAttribute('start') === 'manual') {
          this.viewer.setAttribute('start', 'eager');
        }
        if (this.viewerButtons) {
          this.viewerButtons.classList.remove('is-hidden');
        }
        if (this.trigger && this.secondarySKU) {
          this.trigger.classList.remove('is-hidden');
        }
        if (this.isPackshot && this.packshotContainer) {
          if (this.viewerButtons) {
            if (isMobile()) {
              const galleryButton = this.packshotContainer.querySelector('.power-xyz-3d-viewer-container > button');
              if (galleryButton) {
                galleryButton.setAttribute('disabled', 'true');
              }
            } else {
              this.packshotContainer.setAttribute('disabled', 'true');
            }
          }
        }
        if (this.packshotImg) {
          this.packshotImg.classList.add('is-hidden');
        }
        const zoomableImage = this.querySelector('.component-zoomable-image');
        if (zoomableImage) {
          zoomableImage.remove();
        }
      };
      updatePackshotGalleryViewer = ({
        galleryState
      }) => {
        if (this.packshotContainer) {
          const viewer = this.viewer;
          const mobileClass = isMobile() ? '.sm-only' : '';
          const packshotGallery = this.closest(`product-packshot${mobileClass}`)?.querySelector('.gallery-power-xyz-3d');
          if (packshotGallery) {
            packshotGallery.innerHTML = '';
            if (galleryState === 'open') {
              this.querySelector('power-viewer')?.remove();
              packshotGallery.appendChild(viewer);
            } else {
              const packshotViewerContainer = this.closest('product-packshot')?.querySelector('[data-ref="xyz-viewer-container"]');
              if (packshotViewerContainer) {
                packshotViewerContainer.appendChild(viewer);
              }
            }
          }
        }
      };
      resetPackshotState = () => {
        if (!this.isPackshot || !this.packshotContainer) return;
        if (this.viewerButtons) {
          if (isMobile()) {
            const galleryButton = this.packshotContainer.querySelector('.power-xyz-3d-viewer-container > button');
            if (galleryButton) {
              galleryButton.removeAttribute('disabled');
            }
          } else {
            this.packshotContainer.removeAttribute('disabled');
          }
        }
        const packshotImg = this.querySelector('img.packshot-img');
        packshotImg?.classList.remove('is-hidden');
        const zoomableImage = this.querySelector('.component-zoomable-image');
        zoomableImage?.classList.remove('is-hidden');
      };
      static define = () => {
        if (!customElements.get('product-xyz-3d')) {
          customElements.define('product-xyz-3d', ProductXYZ3D);
        }
      };
    }
    var componentProductXyz3d = () => {
      ProductXYZ3D.define();
    };

    var componentProductXyz3d$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductXYZ3D: ProductXYZ3D,
        default: componentProductXyz3d
    });

    const events = window.PoleneLibs.Events.default;
    class ProductPackshot extends HTMLElement {
      controller = undefined;
      carousel = null;
      images = [];
      activeImage = undefined;
      childType = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      initializeElements = () => {
        this.images = Array.from(this.querySelectorAll('[data-ref="packshot-image"]'));
        this.carousel = this.querySelector(this.dataset.target || 'component-carousel');
        this.childType = this.dataset.childType;
        if (this.childType === 'carousel') {
          const galleryImages = this.querySelector('[data-ref="carousel-slides-container"]')?.querySelectorAll('[data-ref="carousel-slide"]');
          if (galleryImages) {
            this.images.push(...Array.from(galleryImages));
          }
        }
        if (this.images.length > 0) {
          const activeImage = this.images.find(image => image.classList.contains('active'));
          if (activeImage) this.activeImage = activeImage;else {
            this.activeImage = this.images[0];
            this.activeImage.classList.add('active');
          }
        }
        this.setupEventListeners();
      };
      setupEventListeners = () => {
        this.addEventListener(events.ACTIVE_SLIDE_CHANGE, this.handleSlideChange, {
          signal: this.controller?.signal
        });
        this.images.forEach((image, index) => {
          if (!image.dataset.index) image.dataset.index = index;
          image.addEventListener('click', this.handleClick, {
            signal: this.controller?.signal
          });
        });
      };
      handleClick = e => {
        const target = e.currentTarget;
        if (!target || target === this.activeImage) return;
        const targetIndex = +(target.dataset.index ?? this.images.findIndex(image => image === target));
        if (this.carousel && targetIndex >= 0) this.carousel.scrollToIndex(targetIndex, target.dataset.removeSlideTransition === 'true');
      };
      handleSlideChange = e => {
        const event = e;
        if (typeof event.detail.slideIndex !== 'number') return;
        const slideIndex = event.detail.slideIndex;
        const activeImage = this.images[slideIndex].dataset.index == slideIndex ? this.images[slideIndex] : this.images.find(image => image.dataset.index == slideIndex);
        if (activeImage) this.changeActiveImage(activeImage);
        const activeSlide = event.detail.slide;
        if (activeSlide) {
          setTimeout(() => {
            const focusTarget = activeSlide.querySelector('[data-ref="image-zoom-trigger"]') ?? activeSlide;
            focusTarget?.focus();
          }, 200);
        }
      };
      changeActiveImage = target => {
        if (this.activeImage) {
          this.activeImage.classList.remove('active');
          this.activeImage.ariaCurrent = 'false';
        }
        target.classList.add('active');
        target.ariaCurrent = 'true';
        this.activeImage = target;
        this.activeImage.focus();
      };
      static define = () => {
        if (!customElements.get('product-packshot')) {
          customElements.define('product-packshot', ProductPackshot);
        }
      };
    }
    var componentProductPackshot = () => {
      ProductPackshot.define();
    };

    var componentProductPackshot$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductPackshot: ProductPackshot,
        default: componentProductPackshot
    });

    const SELECTORS = {
      SECTION: 'section',
      ADD_TO_CART: '[data-ref="add-to-cart"]'
    };
    class ProductBuyBar extends HTMLElement {
      section = null;
      addToCart = null;
      observer = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupObserver();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      initializeElements = () => {
        this.section = this.closest(SELECTORS.SECTION);
        if (this.section) this.addToCart = this.section.querySelector(SELECTORS.ADD_TO_CART);else this.addToCart = document.body.querySelector(SELECTORS.ADD_TO_CART);
      };
      setupObserver = () => {
        if (this.addToCart) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              this.updateBuyBarVisibility(entry.isIntersecting);
            });
          });
          this.observer?.observe(this.addToCart);
        }
      };
      updateBuyBarVisibility = isAddToCartVisible => {
        if (!this.addToCart) return;
        const rect = this.addToCart.getBoundingClientRect();
        const isPastAddToCart = rect.bottom < 0;
        const product_detail = document.getElementById('product__info__details');
        if (isPastAddToCart && !isAddToCartVisible) {
          this.parentElement?.classList.add('buy-bar-active');
          this.classList.add('active');
          document.body.classList.add('buy-bar-active');
          if (product_detail) product_detail.classList.add('is-scrolled');
        } else {
          this.parentElement?.classList.remove('buy-bar-active');
          this.classList.remove('active');
          if (product_detail) product_detail.classList.remove('is-scrolled');
          document.body.classList.remove('buy-bar-active');
        }
      };
      static define = () => {
        if (!customElements.get('product-buy-bar')) {
          customElements.define('product-buy-bar', ProductBuyBar);
        }
      };
    }
    var componentProductBuyBar = () => {
      ProductBuyBar.define();
    };

    var componentProductBuyBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductBuyBar: ProductBuyBar,
        default: componentProductBuyBar
    });

})();
